import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

// BİLEŞENLERİ İÇERİ AKTAR (Bu kısım eksik olduğu için hata alıyorsun)
// Not: Dosya yollarını (./components/...) kendi klasör yapına göre kontrol et!
import Login from './components/Login';
import Layout from './components/Layout';
import PendingRequests from './components/PendingRequests';
import CompletedRequests from './components/CompletedRequests';
import RejectedRequests from './components/RejectedRequests';
import SiteSettings from './components/SiteSettings';
import BonusManagement from './components/BonusManagement';
import Dashboard from './components/Dashboard';
import DomainSettings from './components/DomainSettings';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const handleTokenUpdate = () => {
      setToken(localStorage.getItem('token'));
    };
    window.addEventListener('storage', handleTokenUpdate);
    return () => window.removeEventListener('storage', handleTokenUpdate);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Giriş sayfası kontrolü */}
        <Route 
          path="/login" 
          element={!token ? <Login /> : <Navigate to="/dashboard" replace />} 
        />

        {/* Korumalı Rotalar (Layout içinde) */}
        <Route 
          path="/" 
          element={token ? <Layout /> : <Navigate to="/login" replace />}
        >
          {/* ARTIK ANA SAYFAMIZ DASHBOARD */}
          <Route index element={<Navigate to="dashboard" replace />} />
          
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="pending-requests" element={<PendingRequests />} />
          <Route path="completed-requests" element={<CompletedRequests />} />
          <Route path="rejected-requests" element={<RejectedRequests />} />
          <Route path="settings/bonuses" element={<BonusManagement />} />
          <Route path="site-settings" element={<SiteSettings />} />
          <Route path="domain-settings" element={<DomainSettings />} />
        </Route>

        {/* Yanlış URL girilirse artık Dashboard'a atıyoruz */}
        <Route path="*" element={<Navigate to={token ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </Router>
  );
};

export default App;